import CustomerLoader from "../../../../../components/CustomLoader";
import { incidentLists } from "../../dummyData/colums";
import {
  dayOfWeekFallIncidentCol,
  doTransformData,
  handlePointClicked,
  transformDataForBarChart,
} from "../formUtils";
import { LayerContent } from "../style";
import { useAnalyticsWrapper } from "../../../../../store/store";
import useAnalytics from "../../../../../hooks/useAnalytics";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import SectionModal, { DefaultContainer } from "./SectionModal";
import { Grid, GridColumn, GridColumnProps } from "@progress/kendo-react-grid";
import {
  CenteredWholeNumCell,
  HeaderCenteredCell,
} from "../../../../../components/DynamicGrid/customCells";
import { TotalRow } from "../../../../../components/DynamicGrid/customRows";
import {
  handleCSVDownload,
  handlePDFDownload,
} from "../../../../../utils/helpers/pdfCsvUtils";

const DayOfWeek = ({
  setClickedIncident,
  isFetchingSelectedIncident,
  shareTableData,
}: any) => {
  const [tableData, setTableData] = useState<any>([]);
  const [grid, setGrid] = useState<any>([]);
  const [barData, setBarData] = useState<any>([]);
  const [dayOfWeek, setDayOfWeek] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [dayOfWeekDetails, setDayOfWeekDetails] = useState<any>([]);

  const { startDate, endDate, fallFacility } = useAnalyticsWrapper((state) => ({
    startDate: state.startDate,
    endDate: state.endDate,
    fallFacility: state.fallFacility,
  }));

  const { getOverviewDayOfWeekFallIncidentAnalysis, getDaysOfWeekDetails } =
    useAnalytics({
      facility: fallFacility?.value || "",
      startDate: moment(startDate).format("yyyy-MM-DD"),
      endDate: moment(endDate).format("yyyy-MM-DD"),
      day: dayOfWeek,
    });

  const { data: dayOfWeekFallIncidentData, isFetching: isLoadingDayOfWeek } =
    getOverviewDayOfWeekFallIncidentAnalysis;

  const { data: dayOfWeekDetailsData, isFetching: isLoadingDetails } =
    getDaysOfWeekDetails;

  useEffect(() => {
    if (dayOfWeekFallIncidentData !== undefined) {
      const tempData = dayOfWeekFallIncidentData?.data?.data;

      const transformedTableData = doTransformData(
        tempData,
        "dataInfo",
        "day",
        "Total Falls"
      );
      setTableData(transformedTableData);
      shareTableData(transformedTableData);
      const transformedBarData = transformDataForBarChart(
        transformedTableData,
        "Day of Week"
      );
      setBarData(transformedBarData);
    }
  }, [dayOfWeekFallIncidentData]);

  useEffect(() => {
    if (dayOfWeekDetailsData) {
      const tempDetails = dayOfWeekDetailsData.data.data.incidentList.map((item: any) => ({
        ...item,
      }));
      setDayOfWeekDetails(tempDetails);
    }
  }, [dayOfWeekDetailsData]);

  const title = "Day of Week Fall Incident Analysis";

  const handleBarClicked = (chart: any) => {
    if (!chart.length) return;
    const label = handlePointClicked(chart, barData?.labels);
    setShowModal(true);
    setDayOfWeek(label);
  };

  useEffect(() => {
    let cellCountProps = {
      cells: { data: CenteredWholeNumCell, headerCell: HeaderCenteredCell },
    };
    let cellPercentageProps = {
      cells: {
        data: CenteredWholeNumCell,
        append: "%",
        headerCell: HeaderCenteredCell,
      },
    };
    const grid = (
      <Fragment>
        <Grid
          data={tableData || []}
          scrollable="none"
          rows={{ data: TotalRow }}
        >
          <GridColumn field="day" title="Day" />
          <GridColumn
            field="count"
            title="Count"
            {...(cellCountProps as GridColumnProps)}
          />
          <GridColumn
            field="percentage"
            title="Percentage"
            {...(cellPercentageProps as GridColumnProps)}
          />
        </Grid>
      </Fragment>
    );
    setGrid(grid);
  }, [tableData]);
  return (
    <LayerContent>
      {isLoadingDayOfWeek ? (
        <CustomerLoader />
      ) : (
        <DefaultContainer
          title={title}
          grid={grid}
          handleBarClicked={(chart: any) => handleBarClicked(chart)}
          barData={barData}
          barType="vertical"
        />
      )}
      {showModal ? (
        <SectionModal
          open={showModal}
          facilityName={fallFacility?.label}
          startDate={startDate}
          endDate={endDate}
          closeFn={() => setShowModal(false)}
          resetFn={() => {
            setDayOfWeek("");
            setDayOfWeekDetails(undefined);
          }}
          isLoading={isLoadingDetails || isFetchingSelectedIncident}
          tableData={dayOfWeekDetails}
          title={`${title} - ${dayOfWeek}`}
          getUserCallback={(item: any) => setClickedIncident(item)}
          handlePdfExport={() =>
            handlePDFDownload({
              data: dayOfWeekDetails,
              columnData: incidentLists(),
              fileName: fallFacility?.label,
              startDate,
              endDate,
              subTitle: `${title} - ${dayOfWeek}`,
            })
          }
          handleCsvExport={() =>
            handleCSVDownload(
              dayOfWeekDetails,
              incidentLists(),
              `${fallFacility?.label} - ${title} - ${dayOfWeek}`
            )
          }
        />
      ) : null}
    </LayerContent>
  );
};

export default DayOfWeek;
